/*
 * Module for the fund picker control
*/
rs.module("ui/controls/html-editor",

    [
        "common/visibility"
    ],

    function (visibility) {
        //
        // Initialize
        //
        function initialize(jsSelectors, trumboIconPath, editorButtons, height, defaultButtons) {
            var content = $.js(jsSelectors.content);
            var placeholder = $.js(jsSelectors.placeholder);

            $.trumbowyg.svgPath = trumboIconPath;
            var buttons = [
                ['viewHTML'],
                ['undo', 'redo'],
                ['fontsize'],
                ['bold', 'italic', 'underline', 'strikethrough'],
                ['link'],
                ['horizontalRule'],
                ['removeformat']
            ];
            if (editorButtons == defaultButtons) {
                buttons = [
                    ['viewHTML'],
                    ['undo', 'redo'],
                    ['fontsize'],
                    ['bold', 'italic', 'underline', 'strikethrough'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['insertImage', 'base64'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat']
                ];
            }
            content.trumbowyg({
                btns: buttons,
                autogrow: false,
                removeformatPasted: true,
                urlProtocol: true
            });
            visibility.hide(placeholder);
            content.siblings(".trumbowyg-editor").css('min-height', height);
            content.parent(".trumbowyg-box").css('min-height', height);

            // Trumbowyg doesn't update the content when using spellcheck from the right click menu, so 
            // this mutation observer detects those changes and triggers keyup to force the update
            new MutationObserver(function () {
                content.siblings(".trumbowyg-editor").keyup();
            }).observe(content.siblings(".trumbowyg-editor")[0], { characterData: true, attributes: false, childList: false, subtree: true });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);